import script from "./AudioPlay.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioPlay.vue?vue&type=script&setup=true&lang=js"

import "./AudioPlay.vue?vue&type=style&index=0&id=3f66df5c&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f66df5c"]])

export default __exports__